import React from 'react';
import cn from 'classname';

import { Field } from 'redux-form';

import InputField from '../../shared/form-elements/input';
import TextareaField from '../../shared/form-elements/new-textarea';

import { isRequired } from '../../shared/form/validation';

import viewInNewWindow from '../../shared/view-in-new-window';

function TemplatesField({ intl, fields, disabled, openTestEmailModal }) {
	function remove(index) {
		if (confirm(intl('Remove template?'))) {
			fields.remove(index);
		}
	}

	return (
		<div className='mailings-new-form-templates-wrapper'>
			{fields.map((name, index) => (
				<div
					className='mailings-new-form-template-wrapper'
					key={index}
				>
					<div className='mailings-new-form-template-fields'>
						<Field
							name={`${name}.title`}
							placeholder={intl('Subject')}
							component={InputField}
							validate={[isRequired]}
							showLabel={false}
							disabled={disabled}
						/>
						<Field
							className='mailings-new-form-template-textarea'
							name={`${name}.text`}
							component={TextareaField}
							validate={[isRequired]}
							disabled={disabled}
						/>
					</div>
					<div className='mailings-new-form-template-actions'>
						<button
							className='mailings-new-form-template-button'
							type='button'
							onClick={() => viewInNewWindow(fields.get(index).text)}
						>
							View
						</button>
						<button
							className={cn(
								'mailings-new-form-template-button',
								'mailings-new-form-template-button-test'
							)}
							type='button'
							onClick={() => openTestEmailModal(index)}
						>
							Send test
						</button>
						{(fields.length > 1) && (
							<button
								className={cn(
									'mailings-new-form-template-button',
									'mailings-new-form-template-button-remove'
								)}
								type='button'
								onClick={() => remove(index)}
								disabled={disabled}
							>
								Remove
							</button>
						)}
					</div>
				</div>
			))}
			<div className='mailings-new-form-templates-buttons'>
				<button
					className='ui-btn ui-btn-secondary'
					type='button'
					onClick={() => fields.push({ id: null, title: '', text: '' })}
					disabled={disabled}
				>
					{intl('Аdd template')}
				</button>
			</div>
		</div>
	);
}

export default TemplatesField;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/components/templates-field.js